<template>
  <teleport to="#title">
    {{ title }}
  </teleport>
  <teleport to="#description">
    {{ description }}
  </teleport>
  <AppNav />
  <RouterView />
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue';
import AppNav from '@/components/AppNav.vue';
import { useStore } from './store';

export default defineComponent({
  components: {
    AppNav,
  },
  setup() {
    const store = useStore();
    const title = computed(() => store.state.meta.title);
    const description = computed(() => store.state.meta.description);
    return { title, description };
  },
});
</script>
